export default "__VITE_ASSET__Cdx3snsx__"